import { render, staticRenderFns } from "./orderDesc.vue?vue&type=template&id=78dc0d5d&scoped=true&"
import script from "./orderDesc.vue?vue&type=script&lang=js&"
export * from "./orderDesc.vue?vue&type=script&lang=js&"
import style0 from "./orderDesc.vue?vue&type=style&index=0&id=78dc0d5d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78dc0d5d",
  null
  
)

export default component.exports